'use client'

import cn from 'clsx'
import { useRect } from 'hamo'
import { Image } from '~/components/image'
import { useScrollTrigger } from '~/hooks/use-scroll-trigger'
import ArrowSVG from '~/public/svg/arrow.svg'

export function Hero({ className }) {
  const [setRectRef, rect] = useRect({
    ignoreTransform: true,
  })

  useScrollTrigger({
    rect,
    start: 'top top',
    end: 'bottom top',
    onProgress: ({ progress }) => {
      if (rect.element) {
        rect.element.style.transform = `translateY(${progress * 20}%)`
      }
    },
  })

  return (
    <section
      className={cn(
        'dr-mt-140 dt:dr-mt-88 max-dt:!transform-[unset]',
        className
      )}
      ref={setRectRef}
    >
      <div className="w-full flex flex-col dr-gap-10 mx-auto dr-mb-72">
        <h1 className="h1 text-balance text-center">
          Give Cora your inbox.
          <br /> Take back your life.
        </h1>

        <p className="p-xl text-balance text-center">
          Cora is the $150,000 chief of staff that only costs $15 per month
        </p>

        <a
          href="https://cora.computer/users/sign_up"
          className="mx-auto flex dr-gap-10 dr-rounded-9999 dr-mt-14 dr-px-20 dr-py-10 bg-white hover:bg-[#d6d6d6] w-fit text-black border-2 border-solid border-[#ffffff] hover:shadow-[-3px_4px_4px_0px_#00000010] hover:backdrop-blur-[20px] transition-all duration-300"
        >
          <span className="cta-rg-l flex-shrink-0">Get started</span>
          <ArrowSVG className="dr-w-16 invert" />
        </a>
      </div>

      <div
        className={cn(
          'dr-w-357 dt:dr-w-915 mx-auto dr-rounded-20 dt:dr-rounded-25 dt:dr-border-5 border-[#DADADA] border-solid bg-secondary dr-p-8 dt:dr-p-15 floating-container'
        )}
      >
        <div className="relative h-full w-full dr-rounded-10 overflow-clip aspect-[0.668] dt:aspect-[1.74]">
          <Image
            className="mobile-only"
            fill
            src="/images/preview-mobile.webp"
            alt=""
            mobileSize="89vw"
            desktopSize="65vw"
            priority
          />
          <Image
            className="desktop-only"
            fill
            src="/images/preview.webp"
            alt=""
            mobileSize="89vw"
            desktopSize="65vw"
            priority
          />
        </div>
      </div>
    </section>
  )
}
